import React from "react";
import Backgroundimage from "../../assets/images/background/image-4.jpg";
import { Link } from "react-router-dom";
import logonew from "../../assets/images/logo.svg";

function Main() {
  // Get the current year dynamically
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="main-footer">
        <div
          className="image-layer"
          style={{ backgroundImage: `url(${Backgroundimage})` }}
        >
          {" "}
        </div>
        <div className="upper-section">
          <div className="auto-container">
            <div className="row clearfix">
              <div className="footer-col info-col col-lg-6 col-md-12 col-sm-12">
                <div
                  className="inner wow fadeInUp"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <div className="content">
                    <div className="logo">
                      <Link to="/" title="cioconat">
                        <img src={logonew} alt="" title="Cioconat" />
                      </Link>
                    </div>
                    <div className="info">
                      <ul>
                        <li> Al-Sha'b St, Dabouq, Amman 11822, JO</li>
                        <li>
                          {/* Resolve conflict - keep local changes */}
                          <Link to="mailto: info@cioconatcafe.com">
                            info@cioconatcafe.com
                          </Link>
                        </li>
                        <li>
                          <Link to="tel:+962--(6)-541-2484">
                            Booking Request : +962-(6)-541-2484
                          </Link>
                        </li>
                        <li>Open : 09:00 am - 01:00 am</li>
                      </ul>
                    </div>
                    <div className="separator">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div className="newsletter">
                      <h3>Get News & Offers</h3>
                      <div className="text">
                        enjoy mouthwatering surprises and tempting offers delivered straight to your inbox!
                      </div>
                      <div className="newsletter-form">
                        <form method="post" action="index.html">
                          <div className="form-group">
                            <span className="alt-icon far fa-envelope"></span>
                            <input
                              type="email"
                              name="email"
                              placeholder="Your email"
                              required
                            />
                            <button
                              type="submit"
                              className="theme-btn btn-style-one clearfix"
                            >
                              <span className="btn-wrap">
                                <span className="text-one">subscribe</span>
                                <span className="text-two">subscribe</span>
                              </span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="footer-col links-col col-lg-3 col-md-6 col-sm-12">
                <div
                  className="inner wow fadeInLeft"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <ul className="links">
                    <li>
                      {" "}
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      {" "}
                      <Link to="/menu">Menus</Link>
                    </li>
                    <li>
                      {" "}
                      <Link to="/about">About us</Link>
                    </li>
                    <li>
                      {" "}
                      <Link to="/ourchefs">Our chefs</Link>
                    </li>
                    <li>
                      {" "}
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer-col links-col last col-lg-3 col-md-6 col-sm-12">
                <div
                  className="inner wow fadeInRight"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <ul className="links">
                    <li>
                      {" "}
                      <Link
                        to="https://www.facebook.com/profile.php?id=100093252044521"
                        target="_blank"
                      >
                        facebook
                      </Link>
                    </li>
                    <li>
                      {" "}
                      <Link
                        to="https://www.instagram.com/cioconatcaferestaurant/"
                        target="_blank"
                      >
                        instagram
                      </Link>
                    </li>
                    <li>
                      {" "}
                      <Link
                        to="https://goo.gl/maps/oDf6LY5eJfupbd196"
                        target="_blank"
                      >
                        Google map
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="auto-container">
            {/* Resolve conflict - keep local changes */}
            <div className="copyright">
              &copy; {currentYear} Cioconat All Rights Reserved
            </div>
          </div>
        </div>
      </footer>
      <div className="scroll-to-top scroll-to-target" data-target="html">
        <span className="icon fa fa-angle-up"></span>
      </div>
    </>
  );
}

export default Main;
